import _styled2, { css as _css, default as _styled3, default as _styled4, default as _styled5, default as _styled6, default as _styled7, default as _styled8, default as _styled9, default as _styled10, default as _styled11, default as _styled12, default as _styled13, default as _styled14, default as _styled15, default as _styled16, default as _styled17, default as _styled18, default as _styled19, default as _styled20, default as _styled21, default as _styled22, default as _styled23, default as _styled24, default as _styled25, default as _styled26 } from "styled-components";
import _styled from "styled-components";
import React from "react";
import { hasItems, takeFirst } from "~/features/app/utils";
import { cleanStegaForTextTransform } from "~/features/sanity/stega";
import { Asset, type Props as AssetProps } from "~/features/craft/asset";
import { Button } from "~/features/ui/button";
import { Link } from "~/features/ui/link";
import { type IconName, type IconComponent } from "~/features/ui/icon";
import ArrowTopRight from "~/public/icons/arrow-top-right.svg";
import ArrowDown from "~/public/icons/arrow-down.svg";
import ArrowLeft from "~/public/icons/arrow-left.svg";
import ArrowRight from "~/public/icons/arrow-right.svg";
import ArrowUp from "~/public/icons/arrow-up.svg";
import CaretDown from "~/public/icons/caret-down.svg";
import CaretLeft from "~/public/icons/caret-left.svg";
import CaretRight from "~/public/icons/caret-right.svg";
import CaretUp from "~/public/icons/caret-up.svg";
import Checkmark from "~/public/icons/checkmark.svg";
import Close from "~/public/icons/close.svg";
import Copy from "~/public/icons/copy.svg";
import Download from "~/public/icons/download.svg";
import EyeOff from "~/public/icons/eye-off.svg";
import EyeOn from "~/public/icons/eye-on.svg";
import HorizontalResolution from "~/public/icons/horizontal-resolution.svg";
import Info from "~/public/icons/info.svg";
import Instagram from "~/public/icons/instagram.svg";
import Language from "~/public/icons/language.svg";
import LinkIcon from "~/public/icons/link.svg";
import Linkedin from "~/public/icons/linkedin.svg";
import Loading from "~/public/icons/loading.svg";
import Location from "~/public/icons/location.svg";
import Menu from "~/public/icons/menu.svg";
import Minus from "~/public/icons/minus.svg";
import Pause from "~/public/icons/pause.svg";
import Play from "~/public/icons/play.svg";
import Plus from "~/public/icons/plus.svg";
import Precision from "~/public/icons/precision.svg";
import Range from "~/public/icons/range.svg";
import Upload from "~/public/icons/upload.svg";
import VerticalResolution from "~/public/icons/vertical-resolution.svg";
import Warning from "~/public/icons/warning.svg";
import Weight from "~/public/icons/weight.svg";
import X from "~/public/icons/x.svg";
import YouTube from "~/public/icons/youtube.svg";
import { isLinkValid } from "~/features/ui/link/utils";
import { Wrap } from "~/features/ui/wrap";
import { Slider, type Shape } from "~/features/ui/slider";
import { Progress } from "~/features/ui/slider/progress";
import { useAnimation } from "./use-animation";
const iconNameMap: Record<IconName, IconComponent> = {
  "arrow-top-right": ArrowTopRight,
  "arrow-down": ArrowDown,
  "arrow-left": ArrowLeft,
  "arrow-right": ArrowRight,
  "arrow-up": ArrowUp,
  "caret-down": CaretDown,
  "caret-left": CaretLeft,
  "caret-right": CaretRight,
  "caret-up": CaretUp,
  checkmark: Checkmark,
  close: Close,
  copy: Copy,
  download: Download,
  "eye-off": EyeOff,
  "eye-on": EyeOn,
  "horizontal-resolution": HorizontalResolution,
  info: Info,
  instagram: Instagram,
  language: Language,
  link: LinkIcon,
  linkedin: Linkedin,
  loading: Loading,
  location: Location,
  menu: Menu,
  minus: Minus,
  pause: Pause,
  play: Play,
  plus: Plus,
  precision: Precision,
  range: Range,
  upload: Upload,
  "vertical-resolution": VerticalResolution,
  warning: Warning,
  weight: Weight,
  x: X,
  youtube: YouTube
};
const ImageWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "technical-comparison__ImageWrapper",
  componentId: "sc-1gukqc3-0"
})(["", " figure,figure img{", "}"], {
  "height": "5.2rem",
  "width": "5.2rem",
  "@media (min-width: 1024px)": {
    "height": "8rem",
    "width": "8rem"
  }
}, {
  "height": "100%",
  "width": "100%",
  "objectFit": "contain"
});
var _StyledImageWrapper = /*#__PURE__*/_styled(ImageWrapper).withConfig({
  displayName: "technical-comparison___StyledImageWrapper",
  componentId: "sc-1gukqc3-1"
})(["", ""], p => p.$_css5);
const Section = /*#__PURE__*/_styled.section.withConfig({
  displayName: "technical-comparison__Section",
  componentId: "sc-1gukqc3-2"
})(["", " .splide__track{overflow:visible !important;}@media (min-width:1024px){.splide__list{justify-content:center !important;}}"], {
  "overflow": "hidden"
});
var _StyledSection = /*#__PURE__*/_styled(Section).withConfig({
  displayName: "technical-comparison___StyledSection",
  componentId: "sc-1gukqc3-3"
})(["", ""], p => p.$_css2);
type PlainAsset = Record<string, unknown>;
type PlainLink = Record<string, unknown> & {
  href?: string;
  newWindow?: boolean;
  text?: React.ReactNode;
};
type SectionDataAttrs = Record<`data-${string}`, string | undefined>;
export type TechnicalComparisonItemLink = {
  link?: PlainLink | null;
  linkIcon?: string | null;
};
export type TechnicalComparisonItem = {
  productImage?: PlainAsset | null;
  illustration?: PlainAsset | null;
  title?: string | null;
  specs?: Array<{
    label?: string | null;
    value?: string | null;
  } | null> | null;
  link?: PlainLink | null;
  supportLink?: PlainLink | null;
  links?: TechnicalComparisonItemLink[] | null;
};
function getPlainLinkIcon(link?: PlainLink | null) {
  if (!link) {
    return undefined;
  }
  return link.newWindow ? ArrowTopRight : ArrowRight;
}
function ItemLink({
  link,
  linkIcon
}: {
  link: PlainLink;
  linkIcon?: string | null;
}) {
  const fallbackIcon = getPlainLinkIcon(link);
  const icon = linkIcon && linkIcon !== "default" ? iconNameMap[linkIcon as IconName] : fallbackIcon;
  return <Button as={Link} {...link} icon={icon} variant="underline" />;
}
export type TechnicalComparisonBlockViewProps = {
  anchor?: Array<{
    id?: string | null;
    name?: string | null;
  }> | {
    id?: string | null;
    name?: string | null;
  } | null;
  hasTopDivider?: boolean | null;
  isHighlighted?: boolean | null;
  items?: TechnicalComparisonItem[] | null;
  mode?: string | null;
  sectionProps?: React.ComponentPropsWithoutRef<"section"> & SectionDataAttrs;
};
export function TechnicalComparisonBlockView({
  anchor,
  hasTopDivider = true,
  isHighlighted = false,
  items,
  mode = "light",
  sectionProps
}: TechnicalComparisonBlockViewProps) {
  const [activeIndex, setActiveIndex] = React.useState(0);
  const sliderRef = React.useRef<Shape>(null);
  const [sliderIndex, setSliderIndex] = React.useState(0);
  const [lastSlideIndex, setLastSlideIndex] = React.useState(0);
  const activeItem = hasItems(items) ? items[activeIndex] : undefined;
  const activeIllustration = activeItem?.illustration;
  const activeLink = activeItem?.link;
  const linkIcon = getPlainLinkIcon(activeLink);
  const hasLink = isLinkValid(activeLink);
  const activeSupportLink = activeItem?.supportLink;
  const supportIcon = getPlainLinkIcon(activeSupportLink);
  const hasSupportLink = isLinkValid(activeSupportLink);
  const activeItemLinks = activeItem?.links;
  const {
    contentRef,
    changeSlide
  } = useAnimation();
  if (!hasItems(items)) {
    return null;
  }
  return <_StyledSection {...sectionProps} data-theme={mode} id={takeFirst(anchor)?.id || undefined} data-anchor-name={takeFirst(anchor)?.name || undefined} $_css2={[{
    "position": "relative",
    "backgroundColor": "var(--bg-tertiary)",
    "color": "var(--text-primary)"
  }, hasTopDivider && {
    "borderTopWidth": "1px",
    "borderColor": "var(--stroke-primary)"
  }, isHighlighted && {
    "backgroundColor": "var(--white-static)"
  }]}>
      <_StyledWrap>
        <_StyledDiv $_css3={[{
        "padding": "var(--spacing-md)",
        "paddingLeft": "var(--spacing-md)",
        "paddingRight": "var(--spacing-md)",
        "@media (min-width: 1024px)": {
          "marginLeft": "auto",
          "marginRight": "auto",
          "paddingTop": "var(--spacing-xl)",
          "paddingBottom": "var(--spacing-xl)"
        }
      }, _css`
              @media (min-width: 1024px) {
                max-width: ${items.length * 14}rem;
              }
            `]}>
          <Slider ref={sliderRef} onMounted={splide => setLastSlideIndex(splide.Components.Controller.getEnd())} onMove={splide => {
          setSliderIndex(splide.Components.Controller.getIndex());
          setLastSlideIndex(splide.Components.Controller.getEnd());
        }} onResized={splide => setLastSlideIndex(splide.Components.Controller.getEnd())} options={{
          autoWidth: true,
          perMove: 1,
          gap: 80,
          breakpoints: {
            1024: {
              gap: 32,
              autoWidth: false,
              perPage: 3
            }
          }
        }}>
            {items.map((item, idx) => {
            const thumb = item.productImage;
            const isActive = idx === activeIndex;
            return <Slider.Slide key={idx} onClick={() => changeSlide(idx, setActiveIndex)}>
                  <_StyledDiv2 $_css4={[{
                "display": "flex",
                "cursor": "pointer",
                "flexDirection": "column",
                "alignItems": "center",
                "gap": "var(--spacing-md)"
              }]}>
                    <_StyledImageWrapper $_css5={[{
                  "transitionProperty": "opacity",
                  "transitionDuration": "250ms"
                }, !isActive && {
                  "opacity": "0.4"
                }]}>
                      {thumb && <Asset asset={thumb as AssetProps["asset"]} imageProps={{
                    fit: "contain"
                  }} />}
                    </_StyledImageWrapper>
                    <_StyledSpan $_css6={[{
                  "fontSize": "1.2rem",
                  "lineHeight": "1.1",
                  "letterSpacing": "0.024rem",
                  "fontWeight": "400",
                  "transitionProperty": "color, background-color, border-color, text-decoration-color, fill, stroke",
                  "transitionDuration": "250ms",
                  "@media (min-width: 1024px)": {
                    "fontSize": "1.4rem",
                    "lineHeight": "1.1",
                    "letterSpacing": "0.028000000000000004rem",
                    "fontWeight": "400"
                  }
                }, !isActive && {
                  "color": "var(--text-transparent)"
                }]}>
                      {item.title}
                    </_StyledSpan>
                    <_StyledSpan2 $_css7={[{
                  "height": "0.8rem",
                  "width": "0.8rem",
                  "--tw-bg-opacity": "1",
                  "backgroundColor": "rgb(75 46 248 / var(--tw-bg-opacity))",
                  "transitionProperty": "transform",
                  "transitionDuration": "250ms"
                }, isActive ? {
                  "--tw-scale-x": "1",
                  "--tw-scale-y": "1",
                  "transform": "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))"
                } : {
                  "--tw-scale-x": "0",
                  "--tw-scale-y": "0",
                  "transform": "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))"
                }]} />
                  </_StyledDiv2>
                </Slider.Slide>;
          })}
          </Slider>
        </_StyledDiv>

        {lastSlideIndex > 0 && <_StyledDiv3 $_css8={[{
        "paddingLeft": "var(--spacing-md)",
        "paddingRight": "var(--spacing-md)",
        "paddingTop": "var(--spacing-lg)",
        "paddingBottom": "var(--spacing-lg)",
        "@media (min-width: 1024px)": {
          "display": "none"
        }
      }]}>
            <Progress activeSlideIndex={sliderIndex} totalSlides={lastSlideIndex + 1} />
          </_StyledDiv3>}

        <_StyledDiv4 ref={contentRef} $_css9={[{
        "display": "grid",
        "gridTemplateColumns": "repeat(12, minmax(0, 1fr))",
        "columnGap": "var(--spacing-md)",
        "borderTopWidth": "1px",
        "borderColor": "var(--stroke-primary)",
        "@media (min-width: 1024px)": {
          "borderWidth": "0px"
        }
      }]}>
          <_StyledDiv5 $_css10={[{
          "position": "relative",
          "gridColumn": "1 / -1",
          "display": "flex",
          "alignItems": "center",
          "justifyContent": "center",
          "padding": "var(--spacing-xl)",
          "@media (min-width: 1024px)": {
            "gridColumn": "span 6 / span 6",
            "paddingLeft": "var(--spacing-3xl)",
            "paddingRight": "var(--spacing-3xl)",
            "paddingTop": "var(--spacing-xl)",
            "paddingBottom": "var(--spacing-xl)"
          }
        }]}>
            <_StyledDiv6 data-animate-title $_css11={[{
            "position": "absolute",
            "left": "var(--spacing-md)",
            "top": "var(--spacing-md)",
            "display": "flex",
            "alignItems": "center",
            "gap": "var(--spacing-xs)",
            "@media (min-width: 1024px)": {
              "bottom": "var(--spacing-xl)",
              "left": "var(--spacing-xl)",
              "top": "auto"
            }
          }]}>
              <_StyledSpan3 $_css12={[{
              "height": "0.8rem",
              "width": "0.8rem",
              "--tw-bg-opacity": "1",
              "backgroundColor": "rgb(75 46 248 / var(--tw-bg-opacity))"
            }]} />
              <_StyledSpan4 $_css13={[{
              "fontSize": "1.4rem",
              "lineHeight": "1.5",
              "letterSpacing": "0.014000000000000002rem",
              "fontWeight": "400",
              "@media (min-width: 1024px)": {
                "fontSize": "1.4rem",
                "lineHeight": "1.5",
                "letterSpacing": "0.014000000000000002rem",
                "fontWeight": "400"
              }
            }]}>{activeItem?.title}</_StyledSpan4>
            </_StyledDiv6>

            {activeIllustration &&
          // data-noparallax: the blueprint illustration must stay static on
          // parallax-enabled pages (the product thumbnails above keep it).
          <_StyledDiv7 data-animate-illustration data-noparallax $_css14={[{
            "maxWidth": "40rem"
          }]}>
                <Asset asset={activeIllustration as AssetProps["asset"]} imageProps={{
              fit: "contain"
            }} />
              </_StyledDiv7>}
          </_StyledDiv5>

          <_StyledDiv8 $_css15={[{
          "gridColumn": "1 / -1",
          "display": "flex",
          "flexDirection": "column",
          "alignItems": "flex-start",
          "justifyContent": "flex-end",
          "gap": "var(--spacing-sm)",
          "padding": "var(--spacing-md)",
          "paddingBottom": "var(--spacing-xl)",
          "@media (min-width: 1024px)": {
            "gridColumn": "span 6 / span 6",
            "padding": "var(--spacing-xl)",
            "paddingBottom": "var(--spacing-xl)"
          }
        }]}>
            {hasItems(activeItem?.specs) && <_StyledDiv9 key={activeIndex} $_css16={[{
            "display": "flex",
            "width": "100%",
            "flexDirection": "column"
          }]}>
                {activeItem.specs.map((spec, idx) => <_StyledDiv10 key={idx} data-animate-spec-row $_css17={[{
              "overflow": "hidden"
            }]}>
                    {idx !== 0 && <_StyledDiv11 data-animate-spec-line $_css18={[{
                "height": "0.1rem",
                "backgroundColor": "var(--bg-transparent-20)"
              }, _css`
                            transform-origin: left center;
                          `]} />}
                    <_StyledDiv12 $_css19={[{
                "display": "flex",
                "alignItems": "center",
                "columnGap": "var(--spacing-lg)",
                "paddingTop": "var(--spacing-md)",
                "paddingBottom": "var(--spacing-md)"
              }]}>
                      <_StyledDiv13 data-animate-spec-label $_css20={[{
                  "minWidth": "7.5rem",
                  "flexShrink": "0",
                  "overflow": "hidden"
                }]}>
                        <_StyledSpan5 $_css21={[{
                    "display": "block",
                    "fontSize": "1.6rem",
                    "lineHeight": "1.5",
                    "fontWeight": "400",
                    "color": "var(--text-primary)",
                    "@media (min-width: 1024px)": {
                      "fontSize": "1.8rem",
                      "lineHeight": "1.5",
                      "letterSpacing": "0.018rem",
                      "fontWeight": "400"
                    }
                  }]}>
                          {spec?.label && cleanStegaForTextTransform(spec.label)}
                        </_StyledSpan5>
                      </_StyledDiv13>
                      <_StyledDiv14 data-animate-spec-value $_css22={[{
                  "overflow": "hidden"
                }]}>
                        <_StyledSpan6 $_css23={[{
                    "display": "block",
                    "fontSize": "1.6rem",
                    "lineHeight": "1.5",
                    "fontWeight": "400",
                    "color": "var(--text-transparent)",
                    "@media (min-width: 1024px)": {
                      "fontSize": "1.8rem",
                      "lineHeight": "1.5",
                      "letterSpacing": "0.018rem",
                      "fontWeight": "400"
                    }
                  }]}>
                          {spec?.value && cleanStegaForTextTransform(spec.value)}
                        </_StyledSpan6>
                      </_StyledDiv14>
                    </_StyledDiv12>
                  </_StyledDiv10>)}
              </_StyledDiv9>}

            {hasItems(activeItemLinks) && <_StyledDiv15 data-animate-links $_css24={[{
            "display": "flex",
            "flexWrap": "wrap",
            "gap": "var(--spacing-md)",
            "@media (min-width: 1024px)": {
              "columnGap": "var(--spacing-2xl)",
              "rowGap": "var(--spacing-md)"
            }
          }]}>
                {activeItemLinks.map((item, idx) => {
              const itemLink = item.link;
              const icon = item.linkIcon;
              return itemLink && isLinkValid(itemLink) ? <ItemLink key={idx} link={itemLink} linkIcon={icon} /> : null;
            })}
              </_StyledDiv15>}

            <_StyledDiv16 $_css25={[{
            "marginTop": "var(--spacing-xl)",
            "display": "flex",
            "alignItems": "center",
            "gap": "var(--spacing-lg)"
          }]}>
              {hasLink && activeLink && <div data-animate-link>
                  <Button as={Link} {...activeLink} icon={linkIcon} variant="secondary" />
                </div>}

              {hasSupportLink && <div data-animate-support>
                  <Button as={Link} {...activeSupportLink} icon={supportIcon} variant="underline" />
                </div>}
            </_StyledDiv16>
          </_StyledDiv8>
        </_StyledDiv4>
      </_StyledWrap>
    </_StyledSection>;
}
var _StyledWrap = /*#__PURE__*/_styled(Wrap).withConfig({
  displayName: "technical-comparison___StyledWrap",
  componentId: "sc-1gukqc3-4"
})({
  "borderWidth": "0px"
});
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "technical-comparison___StyledDiv",
  componentId: "sc-1gukqc3-5"
})(["", ""], p => p.$_css3);
var _StyledDiv2 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "technical-comparison___StyledDiv2",
  componentId: "sc-1gukqc3-6"
})(["", ""], p => p.$_css4);
var _StyledSpan = /*#__PURE__*/_styled("span").withConfig({
  displayName: "technical-comparison___StyledSpan",
  componentId: "sc-1gukqc3-7"
})(["", ""], p => p.$_css6);
var _StyledSpan2 = /*#__PURE__*/_styled("span").withConfig({
  displayName: "technical-comparison___StyledSpan2",
  componentId: "sc-1gukqc3-8"
})(["", ""], p => p.$_css7);
var _StyledDiv3 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "technical-comparison___StyledDiv3",
  componentId: "sc-1gukqc3-9"
})(["", ""], p => p.$_css8);
var _StyledDiv4 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "technical-comparison___StyledDiv4",
  componentId: "sc-1gukqc3-10"
})(["", ""], p => p.$_css9);
var _StyledDiv5 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "technical-comparison___StyledDiv5",
  componentId: "sc-1gukqc3-11"
})(["", ""], p => p.$_css10);
var _StyledDiv6 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "technical-comparison___StyledDiv6",
  componentId: "sc-1gukqc3-12"
})(["", ""], p => p.$_css11);
var _StyledSpan3 = /*#__PURE__*/_styled("span").withConfig({
  displayName: "technical-comparison___StyledSpan3",
  componentId: "sc-1gukqc3-13"
})(["", ""], p => p.$_css12);
var _StyledSpan4 = /*#__PURE__*/_styled("span").withConfig({
  displayName: "technical-comparison___StyledSpan4",
  componentId: "sc-1gukqc3-14"
})(["", ""], p => p.$_css13);
var _StyledDiv7 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "technical-comparison___StyledDiv7",
  componentId: "sc-1gukqc3-15"
})(["", ""], p => p.$_css14);
var _StyledDiv8 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "technical-comparison___StyledDiv8",
  componentId: "sc-1gukqc3-16"
})(["", ""], p => p.$_css15);
var _StyledDiv9 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "technical-comparison___StyledDiv9",
  componentId: "sc-1gukqc3-17"
})(["", ""], p => p.$_css16);
var _StyledDiv10 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "technical-comparison___StyledDiv10",
  componentId: "sc-1gukqc3-18"
})(["", ""], p => p.$_css17);
var _StyledDiv11 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "technical-comparison___StyledDiv11",
  componentId: "sc-1gukqc3-19"
})(["", ""], p => p.$_css18);
var _StyledDiv12 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "technical-comparison___StyledDiv12",
  componentId: "sc-1gukqc3-20"
})(["", ""], p => p.$_css19);
var _StyledDiv13 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "technical-comparison___StyledDiv13",
  componentId: "sc-1gukqc3-21"
})(["", ""], p => p.$_css20);
var _StyledSpan5 = /*#__PURE__*/_styled("span").withConfig({
  displayName: "technical-comparison___StyledSpan5",
  componentId: "sc-1gukqc3-22"
})(["", ""], p => p.$_css21);
var _StyledDiv14 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "technical-comparison___StyledDiv14",
  componentId: "sc-1gukqc3-23"
})(["", ""], p => p.$_css22);
var _StyledSpan6 = /*#__PURE__*/_styled("span").withConfig({
  displayName: "technical-comparison___StyledSpan6",
  componentId: "sc-1gukqc3-24"
})(["", ""], p => p.$_css23);
var _StyledDiv15 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "technical-comparison___StyledDiv15",
  componentId: "sc-1gukqc3-25"
})(["", ""], p => p.$_css24);
var _StyledDiv16 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "technical-comparison___StyledDiv16",
  componentId: "sc-1gukqc3-26"
})(["", ""], p => p.$_css25);